import React from "react";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
  Table,
  UncontrolledTooltip,
} from "reactstrap";

// Requests
import {
  getYearlyIndicatorsRequest,
  deleteYearlyIndicatorRequest,
} from "api/yearlyIndicators";
// Components
import ConfirmationModal from "../../components/ConfirmationModal/ConfirmationModal";

class YearlyIndicators extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      yearlyIndicators: null,
      alert: null,
      total: 0,
      pages: 0,
      current_page: 0,
      start_page: 0,
      end_page: 9,
      first_page: 0,
      last_page: 0,
      deleteYearlyIndicatorId: "",
      filters: { limit: 25 },
      loading: true,
    };
    this.timeout = null;
  }

  async componentDidMount() {
    await this.getYearlyIndicators();
  }

  getYearlyIndicators = async () => {
    this.setState({ loading: true });
    const { filters } = this.state;
    const yearlyIndicatorsObj = await getYearlyIndicatorsRequest(filters);
    const yearlyIndicators = yearlyIndicatorsObj.yearlyIndicators;
    const total = yearlyIndicatorsObj.total;
    const pages = Math.ceil(total / filters.limit);
    const last_page = pages - 1;
    const end_page = pages > 10 ? 9 : pages - 1;

    this.setState({
      yearlyIndicators,
      total,
      pages,
      last_page,
      end_page,
      loading: false,
    });
  };

  onChangeSearch = (event) => {
    const { filters } = this.state;
    this.setState({
      filters: {
        ...filters,
        search: event.target.value,
        page: 0,
      },
    });
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.timeout = setTimeout(() => {
      this.getYearlyIndicators();
    }, 300);
  };

  goTo = (path) => this.props.history.push(path);

  openConfirmation = (id) => () => {
    this.setState({
      deleteYearlyIndicatorId: id,
    });
    this.deleteConfirmationModal.toggle();
  };

  deleteYearlyIndicator = async () => {
    const { deleteYearlyIndicatorId } = this.state;
    await deleteYearlyIndicatorRequest(deleteYearlyIndicatorId);
    this.getYearlyIndicators();
  };

  render() {
    const { yearlyIndicators, loading } = this.state;

    return (
      <>
        <div className="content">
          <Row>
            <Col md="12">
              <Card>
                <CardHeader>
                  <CardTitle className="d-inline-block" tag="h4">
                    Yearly Indicators
                  </CardTitle>
                  <Button
                    className="pull-right mb-3 add-btn"
                    color="primary"
                    onClick={() => this.goTo("/yearly-indicators/create")}
                  >
                    <i className="tim-icons icon-simple-add" /> Indicator
                  </Button>
                </CardHeader>
                <CardBody>
                  <Table responsive>
                    <thead className="text-primary">
                      <tr>
                        <th>Year</th>
                        <th>Land Cost (Sq m.)</th>
                        <th>Land Development Cost (Sq m.)</th>
                        <th>Construction Cost (Sq m.)</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="12">Loading...</td>
                        </tr>
                      ) : yearlyIndicators && yearlyIndicators.length > 0 ? (
                        yearlyIndicators.map((yearlyIndicator) => {
                          const { narra, banyan, redwood, bamboo, oakwood } =
                            yearlyIndicator.constructionCostSqm || {};
                          return (
                            <tr key={yearlyIndicator._id}>
                              <td>{yearlyIndicator.year}</td>
                              <td>{yearlyIndicator.landCostSqm}</td>
                              <td>{yearlyIndicator.landDevCostSqm}</td>
                              <td>
                                Narra: {narra || "N/A"} <br />
                                Banyan: {banyan || "N/A"} <br />
                                Redwood: {redwood || "N/A"} <br />
                                Bamboo: {bamboo || "N/A"} <br />
                                Oakwood: {oakwood || "N/A"}
                              </td>
                              <td className="text-right">
                                {/* <Button
                                                        className="btn-link btn-icon"
                                                        color="success"
                                                        id={`tooltip-view-${broker._id}`}
                                                        size="sm"
                                                        onClick={() => this.goTo(`/broker?id=${broker._id}`)}
                                                    >
                                                        <i className="tim-icons icon-zoom-split" />
                                                    </Button>
                                                    <UncontrolledTooltip
                                                        delay={0}
                                                        target={`tooltip-view-${broker._id}`}
                                                    >
                                                        View
                                                    </UncontrolledTooltip> */}
                                <>
                                  <Button
                                    className="btn-link btn-icon"
                                    color="info"
                                    id={`tooltip-edit-${yearlyIndicator._id}`}
                                    size="sm"
                                    onClick={() =>
                                      this.goTo(
                                        `/yearly-indicators/edit?id=${yearlyIndicator._id}`
                                      )
                                    }
                                  >
                                    <i className="tim-icons icon-pencil" />
                                  </Button>
                                  <UncontrolledTooltip
                                    delay={0}
                                    target={`tooltip-edit-${yearlyIndicator._id}`}
                                  >
                                    Edit
                                  </UncontrolledTooltip>
                                  <Button
                                    className="btn-link btn-icon"
                                    color="danger"
                                    id={`tooltip-delete-${yearlyIndicator._id}`}
                                    size="sm"
                                    onClick={this.openConfirmation(
                                      yearlyIndicator._id
                                    )}
                                  >
                                    <i className="tim-icons icon-simple-remove" />
                                  </Button>
                                  <UncontrolledTooltip
                                    delay={0}
                                    target={`tooltip-delete-${yearlyIndicator._id}`}
                                  >
                                    Delete
                                  </UncontrolledTooltip>
                                </>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="6">
                            There's no yearly indicators to show
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <ConfirmationModal
            ref={(el) => (this.deleteConfirmationModal = el)}
            title="Delete Yearly Indicator?"
            buttons={[
              {
                title: "Cancel",
                className: "btn-primary-override btn btn-primary",
              },
              {
                title: "Delete",
                className: "btn-danger-override btn btn-danger",
                onClick: this.deleteYearlyIndicator,
              },
            ]}
          >
            Are you sure you want to delete this indicator?
          </ConfirmationModal>
        </div>
      </>
    );
  }
}

export default YearlyIndicators;
